import jsPDF from "jspdf";
import { FlashcardCollection } from "../types";

// ... (keep existing translateLatexToText and cleanTextForPdf functions exactly as they are) ...
// --- MATH TRANSLATOR ---
const translateLatexToText = (text: string): string => {
  let t = text;
  while (t.includes("\\frac{")) {
    t = t.replace(/\\frac\{([^{}]+)\}\{([^{}]+)\}/g, "($1 / $2)");
    if (!t.includes("\\frac{")) break;
    t = t.replace(/\\frac/g, "");
  }
  t = t
    .replace(/\\times/g, "×")
    .replace(/\\div/g, "÷")
    .replace(/\\approx/g, "≈")
    .replace(/\\le/g, "≤")
    .replace(/\\ge/g, "≥")
    .replace(/\\neq/g, "≠")
    .replace(/\\%/g, "%")
    .replace(/\^/g, "^");
  t = t
    .replace(/\\textbf/g, "")
    .replace(/\\textit/g, "")
    .replace(/\\text/g, "");
  t = t.replace(/\\$/g, "").replace(/\$/g, "");
  t = t.replace(/\{/g, "").replace(/\}/g, "");
  t = t.replace(/\\/g, " ");
  return t;
};

// --- TEXT CLEANER ---
const cleanTextForPdf = (html: string): string => {
  if (!html) return "";
  const tmp = document.createElement("DIV");
  // Handle both HTML and Markdown bolding
  let cleaned = html
    .replace(/\*\*(.*?)\*\*/g, "$1") // Strip Markdown bold
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<\/p>/gi, "\n\n");
  tmp.innerHTML = cleaned;
  let plainText = tmp.textContent || tmp.innerText || "";
  plainText = translateLatexToText(plainText);
  plainText = plainText.replace(/\. /g, ".\n");
  return plainText.replace(/\n\s*\n\s*\n/g, "\n\n").trim();
};

export const exportToPDF = (collection: FlashcardCollection) => {
  const cards = collection.flashcards;
  const title = collection.name;

  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: [338, 190],
  });

  const width = 338;
  const height = 190;
  const margin = 25;

  const printCardSide = (
    text: string,
    label: string,
    type: string,
    isFront: boolean,
    options?: string[]
  ) => {
    if (isFront) {
      doc.setFillColor(255, 255, 255);
    } else {
      doc.setFillColor(255, 241, 242);
    }
    doc.rect(0, 0, width, height, "F");

    doc.setFontSize(12);
    doc.setTextColor(225, 29, 72);
    doc.setFont("helvetica", "bold");
    doc.text(`${label.toUpperCase()} • ${type.toUpperCase()}`, margin, margin);

    doc.setFontSize(20);
    doc.setTextColor(15, 23, 42);
    doc.setFont("helvetica", "normal");

    const cleanText = cleanTextForPdf(text);
    const splitText = doc.splitTextToSize(cleanText, width - margin * 2.5);

    let contentHeight = splitText.length * 10;
    if (options) contentHeight += options.length * 16;

    let y = height / 2 - contentHeight / 2;
    if (y < 50) y = 50;

    // @ts-ignore
    doc.text(splitText, margin, y);

    if (isFront && options) {
      let optY = y + splitText.length * 10 + 20;
      doc.setFontSize(18);
      doc.setTextColor(51, 65, 85);
      options.forEach((opt) => {
        if (optY < height - margin) {
          doc.text(`•  ${cleanTextForPdf(opt)}`, margin + 10, optY);
          optY += 16;
        }
      });
    }

    doc.setFontSize(10);
    doc.setTextColor(148, 163, 184);
    doc.text(`ScoreSmart • ${title}`, width / 2, height - 10, {
      align: "center",
    });
  };

  cards.forEach((card, i) => {
    if (i > 0) doc.addPage();
    // FIXED: Use default value "basic" if type is undefined
    const safeType = card.type || "basic";

    printCardSide(
      card.front,
      `Card ${i + 1}`,
      safeType,
      true,
      safeType === "mcq" ? card.options : undefined
    );
    doc.addPage();
    printCardSide(card.back, `Card ${i + 1} (Answer)`, safeType, false);
  });

  doc.save(`${title.replace(/\s+/g, "_")}_Flashcards.pdf`);
};